// These fields allign with /CRDataNode/?qualifier=type.name='Dienstverband' and notActive = 0
// values match CRDataNode 'value' property => important for matching on the backend

;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();const contractTypeNodes = ['onbekend', 'Voltijds', 'Deeltijds'] as const;

export type ContractTypeNode = (typeof contractTypeNodes)[number];
export default contractTypeNodes;

export const contractTypeOptions: {
  value: ContractTypeNode;
  labels: { language: 'nl' | 'fr' | 'en'; label: string }[];
}[] = [
  {
    value: 'Voltijds',
    labels: [
      { language: 'nl', label: 'Voltijds' },
      { language: 'fr', label: 'À temps plein' },
      { language: 'en', label: 'Full time' },
    ],
  },
  {
    value: 'Deeltijds',
    labels: [
      { language: 'nl', label: 'Deeltijds' },
      { language: 'fr', label: 'À temps partiel' },
      { language: 'en', label: 'Part time' },
    ],
  },
];
